import { createFileRoute, Navigate, useSearch } from '@tanstack/react-router'
import { z } from 'zod'
import { useAuthStore } from '../store/useAuthStore'
import { WelcomeLogin } from '../modules/auth/WelcomeLogin'

const searchSchema = z.object({
  redirect: z.string().optional(),
})

function IndexPage() {
  const { isAuthenticated } = useAuthStore()
  const { redirect } = useSearch({ from: '/' })

  if (isAuthenticated) {
    // If there's a redirect URL, go there instead of home
    return <Navigate to={redirect || '/home'} />
  }

  return <WelcomeLogin />
}

export const Route = createFileRoute('/')({
  validateSearch: searchSchema,
  component: IndexPage,
})
